<template>
  <div class="form-generator">
    <FormGenerator :data="form" :isLoading="isLoading" @submit="onSubmit" />
  </div>
</template>

<script>
import FormGenerator from '@components/FormGenerator'
import { mapGetters } from 'vuex'

export default {
  name: 'FinancesTaxTypesForm',
  components: { FormGenerator },
  data () {
    return {
      form: {
        startedAt: {
          type: 'datepicker',
          name: 'started_at',
          label: 'Started at*',
          format: 'MM/dd/yyyy',
          value: null,
          validation: [{ name: 'required' }],
          class: 'col-12'
        },
        taxTypeName: {
          type: 'input',
          name: 'tax_type_name',
          label: 'Name*',
          placeholder: 'Enter tax type name',
          valueField: 'id',
          selectLabel: 'name',
          value: null,
          validation: [{ name: 'required' }],
          disabled: this.edit,
          class: 'col-12'
        },
        formulaPercent: {
          type: 'input',
          name: 'formula_percent',
          label: 'Formula percent*',
          placeholder: 'Formula percent - available keywords [$amount]',
          valueField: 'code',
          selectLabel: 'code',
          value: null,
          class: 'col-6'
        },
        formulaFixed: {
          type: 'input',
          name: 'formula_fixed',
          label: 'Formula fixed*',
          placeholder: 'Formula - available keywords [amount]',
          valueField: 'code',
          selectLabel: 'code',
          value: null,
          class: 'col-4'
        },
        currency: {
          type: 'select',
          name: 'currency_id',
          label: 'Currency*',
          selectLabel: 'code',
          valueField: 'id',
          options: [],
          value: null,
          validation: [
            { name: 'required' }
          ],
          class: 'col-2'
        },
        comment: {
          type: 'input',
          name: 'comment',
          label: 'Comment',
          placeholder: 'Comment the previously entered formula',
          value: null,
          validation: [{ name: 'required' }],
          class: 'col-12'
        }
      }
    }
  },
  props: {
    dataProps: {
      type: Object,
      default: () => {}
    },
    isLoading: {
      type: Boolean,
      default: () => false
    }
  },
  mounted () {
    this.setInitialData()
  },
  created () {
    this.$api.finances.getCurrencies()
      .then(values => {
        this.form.currency.options = this.getCurrencies
      })
  },
  computed: {
    ...mapGetters({
      getAllCurrencies: 'getCurrencies'
    }),
    getCurrencies () {
      return this.getAllCurrencies.filter(currency => currency.code === 'UAH' || currency.code === 'USD')
    }
  },
  methods: {
    setInitialData () {
      this.form.startedAt.value = this.dataProps.started_at
        ? this._toLocalTime(this.dataProps.started_at)
        : this._localNowTime()
      this.form.taxTypeName.value = this.dataProps.tax_type_name
        ? this.dataProps.tax_type_name
        : null
      this.form.formulaPercent.value = this.dataProps.formula_percent
        ? this.dataProps.formula_percent
        : null
      this.form.formulaFixed.value = this.dataProps.formula_fixed
        ? this.dataProps.formula_fixed
        : null
      this.form.currency.value = this.dataProps.currency
        ? this.dataProps.currency
        : this.getAllCurrencies.find(currency => currency.code === 'UAH')
      this.form.comment.value = this.dataProps.comment
        ? this.dataProps.comment
        : null
    },

    onSubmit ({ startedAt, taxTypeName, formulaPercent, formulaFixed, currency, comment }) {
      this.$emit('submit', {
        started_at: startedAt.value,
        tax_type_name: taxTypeName.value,
        formula_percent: formulaPercent.value,
        formula_fixed: formulaFixed.value,
        currency_id: currency.value.id,
        comment: comment.value
      })
    }
  }
}
</script>
